jQuery(document).ready(function ($) {
  var $accordionItems = $(".product-details .productView-details .accordion-item");
  var $accordionAnswers = $(".product-details .productView-details .accordion-item .accordion-answer");
  
  // Hide all answers initially
  $accordionAnswers.hide();
  
  // Add click handlers
  $(".product-details .productView-details .accordion-item .accordion-question").click(function (e) {
    e.preventDefault();
    
    var $currentItem = $(this).closest(".accordion-item");
    var $currentAnswer = $currentItem.find(".accordion-answer");
    var isActive = $currentItem.hasClass("active");
    
    // Close all other items
    $accordionItems.not($currentItem).removeClass("active");
    $accordionAnswers.not($currentAnswer).slideUp(300);
    
    // Toggle current item
    if (isActive) {
      $currentItem.removeClass("active");
      $currentAnswer.slideUp(300);
    } else {
      $currentItem.addClass("active");
      $currentAnswer.slideDown(300);
    }
  });

  // // custom qty selector pdp
  // const container = document.getElementById('BundleSelector');
  // const qtyInput = document.querySelector('.quantity__input');

  // if (!container || !qtyInput) return;

  // const grid = container.querySelector('.bundle-grid');
  // const basePrice = window.productBasePrice || 0;

  // function initBundle() {

  //   const rows = document.querySelectorAll(
  //     '.discounty-volume-discount-widget__table tbody tr'
  //   );

  //   if (!rows.length) return false;

  //   const combined = [];

  //   // ✅ Always include default 1 tier
  //   combined.push({ min: 1, discount: 0 });

  //   rows.forEach(row => {

  //     const qtyText = row.querySelector(
  //       '.discounty-volume-discount-widget__criteria'
  //     )?.innerText || '';

  //     const discountText = row.querySelector(
  //       '.discounty-volume-discount-widget__discount'
  //     )?.innerText || '';

  //     const qty = parseInt(qtyText.replace(/\D/g, ''));
  //     const discount = parseFloat(discountText.replace(/[^\d.]/g, ''));

  //     if (!isNaN(qty) && !isNaN(discount)) {
  //       combined.push({ min: qty, discount: discount });
  //     }
  //   });

  //   combined.sort((a, b) => a.min - b.min);

  //   grid.innerHTML = '';

  //   combined.forEach(item => {

  //     const card = document.createElement('div');
  //     card.className = 'bundle-card';
  //     card.dataset.min = item.min;
  //     card.dataset.discount = item.discount;

  //     card.innerHTML = `
  //       <h4 class="card-bundle-title">${item.min}+ BALLS</h4>
  //       <div class="bundle-price"></div>
  //       <span class="save-badge"></span>
  //     `;

  //     grid.appendChild(card);
  //   });

  //   const bundleCards = [...grid.querySelectorAll('.bundle-card')];

  //   function detectTier(qty) {
  //     let active = bundleCards[0];

  //     bundleCards.forEach(card => {
  //       if (qty >= parseInt(card.dataset.min)) {
  //         active = card;
  //       }
  //     });

  //     return active;
  //   }

  //   function updateBundle(qty) {

  //     const active = detectTier(qty);

  //     bundleCards.forEach(card => card.classList.remove('active'));
  //     active.classList.add('active');

  //     const discount = parseFloat(active.dataset.discount);
  //     const discountedUnit = basePrice - (basePrice * discount / 100);
  //     const saved = (basePrice - discountedUnit) * qty;

  //     bundleCards.forEach(card => {
  //       const d = parseFloat(card.dataset.discount);
  //       const unit = basePrice - (basePrice * d / 100);
  //       card.querySelector('.bundle-price').innerHTML =
  //         '$' + unit.toFixed(2) + ' <span class="prefix">/ea</span>';
  //     });

  //     active.querySelector('.save-badge').innerHTML =
  //       discount > 0 ? `Save $${saved.toFixed(2)}` : '';

  //     // Update main price (unit price only)
  //     const priceEl = document.querySelector('.price.price--medium');
  //     if (priceEl) {
  //       priceEl.innerHTML = '$' + discountedUnit.toFixed(2);
  //     }
  //   }

  //   function handleQtyChange() {
  //     const qty = parseInt(qtyInput.value) || 1;
  //     updateBundle(qty);
  //   }

  //   // Input typing
  //   qtyInput.addEventListener('input', handleQtyChange);
  //   qtyInput.addEventListener('change', handleQtyChange);

  //   // Plus / Minus (Ella)
  //   document.addEventListener('click', function(e) {
  //     if (e.target.closest('.btn-quantity')) {
  //       setTimeout(handleQtyChange, 50);
  //     }
  //   });

  //   // Tier click
  //   bundleCards.forEach(card => {
  //     card.addEventListener('click', function () {
  //       qtyInput.value = this.dataset.min;
  //       qtyInput.dispatchEvent(new Event('change'));
  //     });
  //   });

  //   // ✅ Force default quantity 1
  //   qtyInput.value = 1;
  //   updateBundle(1);

  //   return true;
  // }

  // // Wait until Discounty loads
  // const observer = new MutationObserver(() => {
  //   if (initBundle()) {
  //     observer.disconnect();
  //   }
  // });

  // observer.observe(document.body, {
  //   childList: true,
  //   subtree: true
  // });
});

(function () {
  function hideTeamaticalDragPrompt(event) {
    if (!document.body.classList.contains('template-product-summer-teamwear')) return;
    if (!(event.target instanceof Element)) return;

    const container = event.target.closest('.productView-img-container');

    if (!container || container.classList.contains('deploy-teamatical-render-interacted')) return;
    if (!container.querySelector('.media.teamatical-disabled-pointer-events')) return;

    container.classList.add('deploy-teamatical-render-interacted');
  }

  document.addEventListener('pointerdown', hideTeamaticalDragPrompt, true);
  document.addEventListener('mousedown', hideTeamaticalDragPrompt, true);
  document.addEventListener('touchstart', hideTeamaticalDragPrompt, { capture: true, passive: true });
})();
